export const maxScreenWidthForDesktop = 1000


export const screenStaus = {
    seriesScreen: "seriesScreen",
    videoScreen: "videoScreen"
} as const


export const commentsStatus = {
    enabled:"enabled",
    heldForReview:"heldForReview",
    disabled:"disabled",
} as const